import { useDeleteProgram, usePrograms } from "@pbm/programs/hooks";
import { Link, BreadCrumb, Header, Button } from "@funcional/react-ui";
import { Restricted } from "@funcional/react-auth-ui";
import { IntlEnum, IntlDateTime } from "@funcional/react-intl-ui";
import { useMemo } from "react";
import { IProgram } from "@pbm/programs/contracts";
import { Column } from "react-table";
import { useHistory } from "react-router-dom";
import { useI18n } from "@common/helpers";
import {
  DefaultColumnFilter,
  GridView,
  SelectColumnFilter,
} from "@funcional/react-table-ui";

export default function ListProgramPage() {
  const history = useHistory();
  const { intlEnum } = useI18n();
  const { mutateAsync } = useDeleteProgram();
  const {
    status: fetchStatus,
    data: fetchData,
    error: fetchError,
  } = usePrograms();

  const editRecord = (row: any) =>
    history.push(`/pbm/programs/${row.original.code}/edit`);

  const deleteRecord = async (row: any) => {
    if (!window.confirm("Tem certeza de que deseja excluir este registro?")) {
      return Promise.resolve(false);
    }
    try {
      await mutateAsync({
        programCode: row.original.code,
      });
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };
  const enableButtonPriority = (row: any): any => {
    let enableButtonPriority = fetchData?.edges.find(
      (obj) => obj.node.code === row.original.code
    )?.node.enableButtonPriority;
    return !enableButtonPriority;
  };
  const showRecord = (row: any) =>
    history.push(`/pbm/programs/${row.original.code}`);

  const loadProductGroupRules = (row: any) =>
    history.push(`/pbm/programs/${row.original.code}/loadproductgrouprules`);

  const loadCpfs = (row: any) =>
    history.push(`/pbm/programs/${row.original.code}/loadcpf`);

  const cleanCpfs = (row: any) =>
    history.push(`/pbm/programs/${row.original.code}/cleancpf`);

  const loadCnpjs = (row: any) =>
    history.push(`/pbm/programs/${row.original.code}/loadcnpj`);

  const priorityEnable = (row: any) =>
    history.push(
      `/pbm/programs/${row.original.establishmentIdentity}/priority`
    );

  const columns: Column<IProgram>[] = useMemo(
    () => [
      {
        Header: "Prioridade",
        accessor: "priority",
      },
      {
        Header: "Código",
        accessor: "code",
        Filter: DefaultColumnFilter,
        Cell: ({ value }) => <Link to={`/pbm/programs/${value}`}>{value}</Link>,
      },
      { Header: "Nome", accessor: "name" },
      {
        Header: "Tipo",
        accessor: "type",
        Filter: SelectColumnFilter,
        options: [
          { value: "RETAIL", description: intlEnum("program_type", "RETAIL") },
          {
            value: "INDUSTRY",
            description: intlEnum("program_type", "INDUSTRY"),
          },
        ],
        Cell: ({ value }) => <IntlEnum name="program_type" value={value} />,
      },

      {
        Header: "Política Cadastral",
        accessor: "registrationPolicy",
        Cell: ({ value }) => {
          if (!value) {
            return <>Nenhuma</>;
          }

          return (
            <Link to={`/pbm/registration-policies/${value.id}`}>
              {value.description}
            </Link>
          );
        },
      },
      {
        Header: "Início da vigência",
        accessor: "effectiveSince",
        Cell: ({ value }) => <IntlDateTime value={value} />,
      },
      {
        Header: "Fim da vigência",
        accessor: "effectiveUntil",
        Cell: ({ value }) => <IntlDateTime value={value} />,
      },
    ],
    [intlEnum]
  );

  return (
    <>
      <Header
        title="Programas"
        buttons={
          <Restricted to="create.programs">
            <Button
              color="primary"
              onClick={() => history.push(`/pbm/programs/new`)}
            >
              Novo Programa
            </Button>
          </Restricted>
        }
      >
        <BreadCrumb marginBottom={0} items={[{ label: "Programas" }]} />
      </Header>

      <GridView<IProgram>
        accessControlResourceName="programs"
        editRecord={editRecord}
        deleteRecord={deleteRecord}
        showRecord={showRecord}
        loadProductGroupRules={loadProductGroupRules}
        loadCpfs={loadCpfs}
        cleanCpfs={cleanCpfs}
        loadCnpjs={loadCnpjs}
        columns={columns}
        typeMenu={true}
        hook={usePrograms}
        priorityEnable={priorityEnable}
        enableButtonPriority={enableButtonPriority}
      />
    </>
  );
}
